import React, { Component } from 'react';
import { switchModule, setOptions } from '../../../actions/display';
import { connect } from 'react-redux';
import SlideshowMiami from './SlideshowMiami';
import StoryMiami from './StoryMiami';
import StoriesSimpleMiami from './StoriesSimpleMiami';
import StoriesMiami from './StoriesMiami';
import MessageMiami from './MessageMiami';
import NavMiami from './NavMiami';
import TimelineMiami from './TimelineMiami';
import MiamiRecognitionList from './MiamiRecognitionList';
import UserInputMiami from './UserInputMiami';
import MenuButtonMiami from './MenuButtonMiami';
import miamiConstants from './MiamiConstants';
import TouchGestureMiami from './TouchGestureMiami';
import TestMin2 from '../../Test/TestMin2';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { Switch, Route } from 'react-router-dom';
import IdleLoop from '../../../containers/IdleLoop';
import shared from '../../../utils/shared.js';
import _ from 'lodash';


class MiamiContainer extends Component {

  constructor(props) {
    super(props);
    this._screensNumber = this.getScreensNumber();
    this._idleLoopTimeout = null;
    this.idleRef = 0;
    this.state = {
      idle: false,
      xScreens: 1,
      yScreens: 1,
      menuUrl: '/miami/nav',
      showNavButton: false,
      module: null,
      showGesture: false,
      showButton: false
    };
    this._attractLoopFolder = null;
    this._attractLoopModules = null;
    this._swipeAnimationTimerHandler = null;
    this._isSwipeAnimationActive = true;
    this._startButtonRef = null;
    this._swipeTimeout = 5000;
    this._intervalFadeA = null;
    this._intervalFadeB = null;
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  startFadeInterval = (status) => {
    const newStatus = !status;
    if (newStatus) {
      clearTimeout(this._intervalFade);
      this._intervalFadeA = setTimeout(() => {
        if (this.state.idle === true) {
          this.setState({
            showButton: newStatus
          });
          this.animateStartButton(newStatus);
          this.startFadeInterval(newStatus);
        }
      }, 5000);
    } else {
      clearTimeout(this._intervalFade);
      this._intervalFadeB = setTimeout(() => {
        if (this.state.idle === true) {
          this.animateStartButton(newStatus);
          setTimeout(() => {
            if (this.state.idle === true) {
              this.setState({
                showButton: newStatus
              });
            }
            this.startFadeInterval(newStatus);
          }, 2000);
        }
      }, 5000);
    }
  }

  animateStartButton = (show) => {
    if (this._startButtonRef) {
      if (show) {
        this._startButtonRef.animate([
          {
            transform: "scale(1)",
          },
          {
            transform: "scale(1.25)",
          }
        ], {
          fill: "forwards",
          duration: 2000
        });
      } else {
        this._startButtonRef.animate([
          {
            transform: "scale(1.25)",
          },
          {
            transform: "scale(0.75)",
          }
        ], {
          fill: "forwards",
          duration: 2000
        });
      }
    }
  }

  handleSwipeAnimation = (wrapperHeight, contentHeight) => {
    if (contentHeight > wrapperHeight && this._isSwipeAnimationActive) {
      clearTimeout(this._swipeAnimationTimerHandler);
      this._swipeAnimationTimerHandler = setTimeout(() => {
        const pathName = this.props.location.pathname;
        if (["/miami/nav/slideshow", "/miami/message", "/miami/nav"].indexOf(pathName) === -1) {
          this.setState({
            showGesture: true
          });
        }
        setTimeout(() => {
          this.setState({
            showGesture: false
          });
        }, 3500);

        if (this._isSwipeAnimationActive) {
          this._swipeTimeout = 20000;
          this.handleSwipeAnimation(wrapperHeight, contentHeight);
        }
      }, this._swipeTimeout);
    } else {
      clearTimeout(this._swipeAnimationTimerHandler); 
    }
  }

  activateSwipeAnimation = () => {
    this._isSwipeAnimationActive = true;
    clearTimeout(this._swipeAnimationTimerHandler);
  }

  cancelSwipeAnimation = () => {
    this.setState({
      showGesture: false
    });
    this._isSwipeAnimationActive = false;
    clearTimeout(this._swipeAnimationTimerHandler);
  }

  toggleShowNav = (toggleOn) => {
    this.setState({
      showNavButton: toggleOn
    })
  }

  setMenuBtn = (x, y, url) => {
    this.setState({
      xScreens: x,
      yScreens: y,
      menuUrl: url
    });
  }

  navRoute = (route, module) => {
    this.setState({
      module: module
    })
    this.props.history.replace(route);
  }

  openNav = () => {
    this.setState({
      showGesture: false
    })
    this.props.history.replace(this.state.menuUrl);
  }

  getScreensNumber = () => {
    try {
      return this.props.content.settings.display_blocks[0].screens.length
    } catch(e) {
      return 1;
    }
  }

  goIdle = (type) => {
    if (type === "recentInteraction") {
      this.setState({
        recentInteraction: false
      })
    } else {
      clearTimeout(this._intervalFadeA);
      clearTimeout(this._intervalFadeB);
      this.setState({
        idle: true,
        showButton: true
      });
      this.startFadeInterval(true);
      setTimeout(() => this.animateStartButton(true), 500);
      this._attractLoopFolder = this.getAttractLoopFolder();
      if (this._attractLoopFolder !== undefined && this._attractLoopFolder !== null) {
        this._attractLoopModules = this.getAttractLoopFolderModules(this._attractLoopFolder);
        this.cycleIdle();
        // this.cycleIdleLoop();
      }
    }
  }

  getAttractLoopFolder = () => {
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const attractLoopFolder = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return type === "attract_loop" && folder.parent_category === Number(rootFolderId)
    });
    return attractLoopFolder;
  }

  getAttractLoopFolderModules = (attractLoopFolder) => {
    return this.props.content.folder_modules
    .filter(fm => fm.folder === attractLoopFolder.id)
    .map(fm => {
      const displayModule = this.props.content.dm_active.find(dm => dm.id === fm.module_id);
      displayModule.rank = fm.rank;
      return displayModule;
    })
    .sort((a, b) => {
      return a.rank - b.rank
    });
  }

  resume = () => {
    this._isSwipeAnimationActive = true;
    if (this.state.idle === true) {
      clearTimeout(this._idleLoopTimeout);
      clearTimeout(this._intervalFadeA);
      clearTimeout(this._intervalFadeB);
      this.setState({
        idle: false,
        showButton: false
      });
      this.props.history.replace('/miami/nav');
    }
    if (this.state.recentInteraction === false) {
      this.setState({
        recentInteraction: true
      })
    }

  }

  cycleIdle = () => {
    this.idleRef++;

    if (this.idleRef >= this._attractLoopModules.length) {
      this.idleRef = 0
    }

    const selectedModule = this._attractLoopModules[this.idleRef];
    //const displayModuleType = this.props.content.display_module_types.find(dmt => dmt.id === selectedModule.display_module_type);
    //console.log("before nav route", selectedModule);
    this.navRoute('/miami/nav/slideshow?id='+selectedModule.id, selectedModule);
  }

  cycleIdleLoop = () => {
    clearTimeout(this._idleLoopTimeout);
    this._idleLoopTimeout = setTimeout(() => {
      this.cycleIdle();
      this.cycleIdleLoop();

    }, 2000);
  }

  handleKeyDown = (event) => {
    switch (event.key) {
      case "s":
        console.log(this.props);
        break;
      case "n":
        this.openNav();
        break;
      default:
        break;
    }
  }

  showNavButton = (show) => {
    this.setState({
      showNavButton: show
    });
  }

  render() {
    const { location } = this.props;
    const key = this.props.location.pathname + this.props.location.search;
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    const colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    const className = this.props.content.font_class + " horizontal-screen-any";
    return (
      <div className={className} style={{ color: this.props.content.settings.main_font_color }}>
        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='fastfadedelay'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <Switch key={key} location={location}>
            <Route path='/miami/nav/slideshow' render={props => <SlideshowMiami {...props} module={this.state.module} idle={this.state.idle} />} />
            <Route path='/miami/nav' render={props => <NavMiami {...props} toggleShowNav={this.toggleShowNav} navRoute={this.navRoute} content={this.props.content} screen={this.props.screen} screensNumber={this._screensNumber} cancelSwipeAnimation={this.cancelSwipeAnimation} />} />
            <Route path='/miami/message' render={props => <MessageMiami {...props} content={this.props.content} module={this.state.module} toggleShowNav={this.toggleShowNav} navRoute={this.navRoute} screen={this.props.screen} setMenuBtn={this.setMenuBtn} screensNumber={this._screensNumber}/>} />
            <Route path='/miami/story' render={props => <StoryMiami {...props} backgroundEnabled={true} module={this.state.module} content={this.props.content} navRoute={this.navRoute} screen={this.props.screen} screensNumber={this._screensNumber} handleSwipeAnimation={this.handleSwipeAnimation} cancelSwipeAnimation={this.cancelSwipeAnimation}/>} />
            <Route path='/miami/stories' render={props => <StoriesSimpleMiami {...props} module={this.state.module} navRoute={this.navRoute} screen={this.props.screen} screensNumber={this._screensNumber} handleSwipeAnimation={this.handleSwipeAnimation} cancelSwipeAnimation={this.cancelSwipeAnimation}/>} />
            <Route path='/miami/storypills' render={props => <StoriesMiami {...props} module={this.state.module} navRoute={this.navRoute} screen={this.props.screen} mode="story" showNavButton={this.showNavButton} screensNumber={this._screensNumber} handleSwipeAnimation={this.handleSwipeAnimation} cancelSwipeAnimation={this.cancelSwipeAnimation} />} />
            <Route path='/miami/storiespictures' render={props => <StoriesSimpleMiami {...props} module={this.state.module} navRoute={this.navRoute} screen={this.props.screen} screensNumber={this._screensNumber} handleSwipeAnimation={this.handleSwipeAnimation} cancelSwipeAnimation={this.cancelSwipeAnimation}/>} />
            <Route path='/miami/videopills' render={props => <StoriesMiami {...props} navRoute={this.navRoute} screen={this.props.screen} mode="video" showNavButton={this.showNavButton} screensNumber={this._screensNumber} handleSwipeAnimation={this.handleSwipeAnimation} cancelSwipeAnimation={this.cancelSwipeAnimation}/>} />
            <Route path='/miami/timeline' render={props => <TimelineMiami {...props} content={this.props.content} module={this.state.module} navRoute={this.navRoute} screen={this.props.screen} screensNumber={this._screensNumber} cancelSwipeAnimation={this.cancelSwipeAnimation}/>} />
            <Route path='/miami/recognitionlist' render={props => <MiamiRecognitionList {...props} module={this.state.module} content={this.props.content} navRoute={this.navRoute} screen={this.props.screen} screensNumber={this._screensNumber} handleSwipeAnimation={this.handleSwipeAnimation} cancelSwipeAnimation={this.cancelSwipeAnimation}/>} />
            <Route path='/miami/subscribe' render={props => <UserInputMiami {...props} navRoute={this.navRoute} content={this.props.content} module={this.state.module} screen={this.props.screen} screensNumber={this._screensNumber} handleSwipeAnimation={this.handleSwipeAnimation} cancelSwipeAnimation={this.cancelSwipeAnimation} activateSwipeAnimation={this.activateSwipeAnimation}/>} />
            <Route path='/miami/test' render={props => <TestMin2 {...props} navRoute={this.navRoute} screen={this.props.screen} screensNumber={this._screensNumber}/>} />
          </Switch>
        </CSSTransitionGroup >

        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showNavButton}>
            {this.state.showNavButton && !this.state.idle ?
              <MenuButtonMiami
                unit={this.props.screen.r9_16.p10 / this.props.screensNumber}
                width="3.90625vh"
                height={miamiConstants.menuButtonHeight}
                top="50vh"
                border="0.84375vh"
                clickAction={this.openNav}
                text={'menu'}
                colorPallette={colorPallette}
              >
              </MenuButtonMiami>
              : null}
          </div>
        </CSSTransitionGroup >

        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={2000}
          transitionLeaveTimeout={2000}>
          <div key={this.state.showButton}>
            {this.state.showButton ?
            <div ref={el => this._startButtonRef = el} style={{ position:"absolute", top:"43.356510416vh", width:this.props.screen.screenWidth / this._screensNumber, height:"5vh", textAlign:"center" }}>
              <div style={{ width:"100%" }}>
                <img style={{ maxWidth: "12vh", maxHeight:"12vh" }} src="/img/miami/ui/start.png" alt=""/>
              </div>
              {/* <div style={{ width:"100%" }}>
                <span style={{ color: "#999699", fontSize:"2.5vh" }}>TOUCH TO BEGIN</span>
              </div> */}
            </div>
            :null
            }
          </div>
        </CSSTransitionGroup>

        {
          this.props.idleActive === true ? 
          <IdleLoop
          idle_delay={this.props.content.idle_delay}
          goIdle={this.goIdle}
          resume={this.resume}
          />
          :
          null
        }

        {/* Touch Gesture */}
        <TouchGestureMiami
          screen={this.props.screen}
          regionWidth={this.props.screen.screenWidth / this._screensNumber}
          regionHeight={this.props.screen.screenHeight}
          contentX={20}
          contentY={20}
          show={this.state.showGesture}
        />
      </div >
    )
  }
}

const mapStateToProps = (state) => {
  let active_module = state.active_module
  let idle = shared.parseStringParam(window.location.href, "idle");
  let namedmodule = shared.parseStringParam(window.location.href, "name");

  let idleActive = true;
  if (state.content.idle_delay === 0 || idle === "false") {
    idleActive = false;
  }

  if (namedmodule) {
    active_module = _.findIndex(state.content.dm_active, { name: decodeURIComponent(namedmodule) });
  }

  return {
    active_module: active_module,
    content: state.content,
    contentHasErrored: state.contentHasErrored,
    contentIsLoading: state.contentIsLoading,
    donors: state.donors,
    donorsHasErrored: state.donorsHasErrored,
    donorsIsLoading: state.donorsIsLoading,
    screen: state.screen,
    options: state.options,
    screensNumber: state.screensNumber,
    idleActive: idleActive,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    switchModule: (id) => dispatch(switchModule(id)),
    setOptions: (data) => dispatch(setOptions(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MiamiContainer);


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/MiamiContainer.js